var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.8333C13.5943 16.8333 17.3333 13.0943 17.3333 8.49999C17.3333 3.90566 13.5943 0.166656 9 0.166656C4.40567 0.166656 0.666672 3.90566 0.666672 8.49999C0.666672 13.0943 4.40567 16.8333 9 16.8333ZM9 1.33968C12.9345 1.33968 16.1603 4.54105 16.1603 8.49999C16.1603 12.4589 12.9345 15.6603 9 15.6603C5.0655 15.6603 1.83969 12.4345 1.83969 8.49999C1.83969 4.56548 5.0655 1.33968 9 1.33968ZM7.60705 12.1656C7.28935 12.1656 7.02054 12.4344 7.02054 12.7521C7.02054 13.0698 7.28935 13.3386 7.60705 13.3386H11.4682C11.7859 13.3386 12.0547 13.0698 12.0547 12.7521C12.0547 12.4344 11.7859 12.1656 11.4682 12.1656H10.1242V6.98476C10.1242 6.66706 9.85534 6.39825 9.53764 6.39825H7.60705C7.28935 6.39825 7.02054 6.66706 7.02054 6.98476C7.02054 7.30245 7.28935 7.57127 7.60705 7.57127H8.95113V12.1656H7.60705ZM9.68433 4.46741C9.68433 4.99378 9.25763 5.42049 8.73125 5.42049C8.20488 5.42049 7.77818 4.99378 7.77818 4.46741C7.77818 3.94103 8.20488 3.51433 8.73125 3.51433C9.25763 3.51433 9.68433 3.94103 9.68433 4.46741Z",
    fill: "#677B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.64d5ea3ce673527625c51b2a3c1a4fdf.svg";
export { ForwardRef as ReactComponent };